<script setup lang="ts">
import getDailyReportEditStatus from '@/types/responses/getDailyReportEditStatus';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';

const props = defineProps<{
  deliveryPlanChildren: getDailyReportEditStatus[]
}>();

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}
</script>
<template>
  <v-col cols="8">
    <v-table>
      <thead>
        <tr>
          <th></th>
          <th>
            <div class="d-flex justify-center">
              {{ i18n.global.t('pages.dailyReports.mergeForm.leavingWarehouse') }}
            </div>
          </th>
          <th>
            <div class="d-flex justify-center">
              {{ i18n.global.t('pages.dailyReports.mergeForm.returningWarehouse') }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(child, index) in props.deliveryPlanChildren" :key="index">
          <td>
            <div class="d-flex justify-center">
              {{ i18n.global.t('pages.dailyReports.mergeForm.tripId') }} {{ child.delivery_plan_id }}
            </div>
          </td>
          <td>
            <div class="d-flex justify-center">
              {{ changeFormat(child.delivery_plan_vehicle_information.leaving_warehouse_date_time) }}
            </div>
          </td>
          <td>
            <div class="d-flex justify-center">
              {{ changeFormat(child.delivery_plan_vehicle_information.returning_warehouse_date_time) }}
            </div>
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-col>
</template>
<style scoped>
.v-table tbody tr:hover {
  background-color: white !important;
}
.v-table thead tr th {
  border: none !important;
}
.v-table tbody tr td {
  border: none !important;
}
</style>
